export default __webpack_public_path__ + "static/media/11.a190bb6f.png";